import { MAX_MOBILE_WIDTH } from "constants/config";
import { useAppDispatch } from "hooks/useStore";
import { useCallback, useEffect } from "react";
import {
  set1024WideScreen,
  set640WideScreen,
  set898WideScreen,
  setIsMobile,
  setSidebarOpen,
} from "store/slices/setting";

function HandleScreenSizes() {
  const dispatch = useAppDispatch();

  const settingIsMobile = useCallback(() => {
    dispatch(setIsMobile(window.innerWidth < MAX_MOBILE_WIDTH));
    dispatch(set898WideScreen(window.innerWidth < 898));
    dispatch(set1024WideScreen(window.innerWidth < 1024));
    dispatch(set640WideScreen(window.innerWidth < 640));
  }, [dispatch]);

  useEffect(() => {
    settingIsMobile();

    const isDesktop = typeof window !== undefined && window.innerWidth >= 898;
    dispatch(setSidebarOpen(isDesktop));

    // Remove the temp sidebar class immediately
    const body = document.body;
    body.classList.remove("sidebar-temp-initial-state");

    // Keep sidebar hidden only if not desktop
    if (!isDesktop) {
      body.classList.add("sidebar-hidden");
    }

    addEventListener("resize", (event) => {
      settingIsMobile();
    });
  }, [settingIsMobile]);

  return null;
}

export default HandleScreenSizes;
